var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-container container"},[_vm._m(0),_c('div',{staticClass:"title"},[_c('p',[_vm._v(" "+_vm._s(_vm.about1)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.about2)+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-picture"},[_c('img',{attrs:{"src":require("../assets/poza_mea.jpeg")}})])
}]

export { render, staticRenderFns }